/* eslint-disable import/no-anonymous-default-export */
import {
  LOGIN_USER,
  LOGOUT,
  LOAD_USER,
} from "../actions/types";

const initialState = {
  token: JSON.parse(localStorage.getItem("AuthData"))?.access_token,
  user: null,
  errors: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_USER:
      return {
        ...state,
        user: action.payload,
      };
    case LOGIN_USER:
      localStorage.setItem("AuthData", JSON.stringify(action.payload));
      return {
        ...state,
        token: action.payload,
      };
    case LOGOUT:
      localStorage.removeItem("AuthData");
      return {
        ...state,
        token: null,
        user: null,
      };
    default:
      return state;
  }
};